'use strict';

angular.module('atex.dam').controller('DamQueryListController', ['$rootScope', '$scope', 'DamService', 'ContentService', '$q', '$modal',
  'DamDynamicQueriesService', '$timeout', 'DamQueryService', 'AssignService', 'DamNotificationService', 'AuthenticationService', 'DamSearchService', 'configuration', 'DamFoldersService', 'DamQueuesService', '$translate', '$interval','$location',
  function ($rootScope, $scope, DamService, ContentService, $q, $modal,
            DamDynamicQueriesService, $timeout, DamQueryService, AssignService, DamNotificationService, AuthenticationService, DamSearchService, configuration, DamFoldersService, DamQueuesService, $translate, $interval, $location) {

    $scope.queries = [];
    $rootScope.queriesAccessible = $scope.queries;
    $scope.currentSearchDamID = undefined;

    $scope.tooltipPrefix = 'Created by: ';

    $scope.$on("onecms:authenticationSuccess", function () {
      $scope.queries = [];
      $rootScope.queriesAccessible = $scope.queries;
      $scope.currentSearchDamID = undefined;
      queries();
    });

    var querying = false;
    $scope.$on("dam:beforeExecuteQuery", function () {
      querying = true;
    });
    $scope.$on("dam:afterExecuteQuery", function () {
      querying = false;
    });

    $scope.$on("dam:startNewQuery", function () {
      $scope.currentSearchDamID = undefined;
    });

    $scope.counter = 0;

    $scope.$on("dam:displayChangeEvent", function(event, displayObject) {
      $scope.counter = 0;
      $interval.cancel($scope.promise);
      if(!$scope.currentSearchDamID) {
        return;
      }
      else {
        angular.forEach($scope.queries, function (queryEntry) {
          if (queryEntry.search.damid === $scope.currentSearchDamID) {
            queryEntry.search.container.aspects.contentData.data.display=displayObject.display;
            if(queryEntry.status !== 'query-list-status-not-saved') {
              $scope.promise = $interval(function() {
                $scope.counter = $scope.counter + 1;
                if($scope.counter > 5) {
                  $interval.cancel($scope.promise);
                  $scope.counter = 0;
                  if(queryEntry.isCurrentOwner) {
                    $scope.update(queryEntry, true);
                  }
                }
              }, 1000);
            }
          }
        });
      }
    });

    $scope.$on("dam:search", function (event, search, googleSearch) {

      if(search.damid) {
        $scope.currentSearchDamID = search.damid;
        angular.forEach($scope.queries, function (queryEntry) {
          if (queryEntry.search.damid === $scope.currentSearchDamID) {
            // to make sure the saved display setting is not overridden by the default.
            var size = atex.onecms.ObjectUtils.getByPath(queryEntry, "search/container/aspects/contentData/data/display");
            if (size) {
              $interval(function () {
                $scope.$root.$broadcast("dam:closingThumbExpander");
                $scope.$root.$broadcast("dam:setSliderEvent", {display: size});
              }, 500, 1);
            }
          }
        });
      }
      if (search.damid && !search.container.aspects.contentData.data.hiddenQuery && !search.isFaceting) {
        search.googleSearch = googleSearch;
        entry(search);
      }
    });

    $scope.$on("dam:loadConfigurationEnd", function () {
      $scope.empty = $translate.getTranslationTable().__EMPTY__;
      $scope.tooltipPrefix = $translate.getTranslationTable().__CREATED_BY__ + ": ";
    });

    $scope.$on("dam:dynamicUpdate", function (event, response) {
      if (querying) {
        return;
      }
      angular.forEach(response.qList, function (item) {
        angular.forEach($scope.queries, function (queryEntry) {
          if (queryEntry.search.damid === item.damid) {
            queryEntry.increment = item.count - queryEntry.size;
            if(queryEntry.increment < 0) {
              $rootScope.$broadcast("dam:contentRemoved", item.damid, queryEntry.increment);
            } else {
              $rootScope.$broadcast('dam:contentAdded', item.damid, queryEntry.increment);
            }
          }
        });
      });
    });

    function findUserById(users, userId) {
      var user = _.find(users, function(obj) {
        return obj.principalId === userId;
      });
      return user;
    }

    // Possible icons:
    // Query is only mine: isShared == false, isCurrentOwner = true;
    // Query is shared and I can modify: isShared == true, isCurrentOwner = true;
    // Query is shared and I cannot modify: isShared == false, isCurrentOwner = false;
    var setIsCurrentOwner = function (queryEntry) {
    if (queryEntry.status === 'query-list-status-not-saved') {
        delete queryEntry.isShared;
        delete queryEntry.isCurrentOwner;
        delete queryEntry.isCurrentOwnerAsGroup;
        return;
      }

      return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
        var isOwner = false;
        var creator = '';
        if (!queryEntry.search.container.aspects['atex.dam.standard.ContentAccess']) {
          return;
        }
        if (queryEntry.search.container.aspects['atex.dam.standard.ContentAccess'].data.assignees.length>1) {
          queryEntry.isShared = true;
          creator = queryEntry.search.container.aspects['atex.dam.standard.ContentAccess'].data.creator;
          DamService.getUsers().then(function(users) {
            var user = findUserById(users, creator);
            queryEntry.creatorName = (user && user.name) ? user.name : creator;
            queryEntry.creatorName = queryEntry.creatorName.charAt(0).toUpperCase() + queryEntry.creatorName.substring(1);
          });
        } else {
          queryEntry.isShared = false;
          queryEntry.creatorName = '';
        }
        queryEntry.search.container.aspects['atex.dam.standard.ContentAccess'].data.assignees.forEach(function (assignee) {
          if (isOwner) {
            return;
          }
          if (assignee.externalId.indexOf('group') === 0) {
            // The query is at least assigned to a group (so it's shared)
            queryEntry.isShared = true;
            if (AssignService.findGroupById(currentUserInfo.groups, assignee.externalId)) {
              if (assignee.owner) {
                isOwner = true;
                queryEntry.isCurrentOwner = true;
                return;
              } else {
                queryEntry.isCurrentSharedAsGroup = true;
              }
            }
          } else {
            if (assignee.owner && assignee.externalId === currentUserInfo.externalId) {
              isOwner = true;
              queryEntry.isCurrentOwner = true;
              return;
            }
          }
        });
        if (!isOwner) {
          queryEntry.isShared = true;
          queryEntry.isCurrentOwner = false;
          queryEntry.isCurrentOwnerAsGroup = false;
        }
      });
    };

    $scope.search = function (queryEntry) {
      queryEntry.size = '...';  // Use the sequence '...' in order to display spinner in UI
      DamFoldersService.resetSelection(true);
      DamQueuesService.resetSelection(true);
      queryEntry.increment = 0;
      $rootScope.physSingleEdition = atex.onecms.ObjectUtils.getByPath(queryEntry, "search/container/aspects/contentData/data/singleEdition");
      var viewMode = atex.onecms.ObjectUtils.getByPath(queryEntry, "search/container/aspects/contentData/data/viewMode");
      var ts = Date.now();
      DamSearchService.setLastQueryStartTs(ts);
      var extraInfo = {
        queryTs: ts
      };


      DamSearchService.runQueryContainer(queryEntry.search, extraInfo);

      if(viewMode) {
        $rootScope.$broadcast("dam:setViewMode", viewMode);
      }

      if(DamService.isMobileDevice()) {
        $rootScope.$broadcast("dam:toggle");
      }

      $rootScope.$broadcast("dam:queryListSearch",atex.onecms.ObjectUtils.getByPath(queryEntry, "search/container/aspects/contentData/data"));
    };

    function sortQueries() {
      $scope.queries.sort(function (a, b) {
        if (a.search.container.aspects.contentData.data.name > b.search.container.aspects.contentData.data.name) {
          return 1;
        }
        if (a.search.container.aspects.contentData.data.name < b.search.container.aspects.contentData.data.name) {
          return -1;
        }
        return 0;
      });
    }

    $scope.save = function (queryEntry) {
      delete queryEntry.googleSearch;
      if (queryEntry.status === 'query-list-status-not-saved') {
        return DamQueryService.createQuery(queryEntry.search.container.aspects.contentData).then(function (response) {
          queryEntry.status = "query-list-status-saved";
          queryEntry.search.id = response.id;
          queryEntry.search.revision = response.revision;
          queryEntry.search.container.aspects = response.data.aspects;
          setIsCurrentOwner(queryEntry);

          DamNotificationService.addNotification(atex.dam.Notification({ type: 'success', message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__ }), false);

          // If it's dynamic query try to add it to poller, starting from this changelist the not saved queries
          // are not sent to the poller in the 'function entry' [max]
          if (queryEntry.search.container.aspects.contentData.data.isDynamic === 'true') {
            DamDynamicQueriesService.addUpdateQuery(queryEntry.search.damid, buildFilteredQueryStr(queryEntry.search.container.aspects.contentData));
          }

          return queryEntry;
        });
      } else {
        return $q.when(queryEntry);
      }
    };

    var removeQueryFromList = function (queryEntry) {
      angular.forEach($scope.queries, function (query, key) {
        if (!query || query.search.damid === queryEntry.search.damid) {
          $scope.queries.splice(key, 1);
        }
      });
      // remove from dynamic query list if it's in the list
      DamDynamicQueriesService.removeQuery(queryEntry.search.damid);
    };

    $scope.canRemove = function (queryEntry) {
      var valCurrentOwner = queryEntry.isCurrentOwner;
      var valSharedAsGroup = queryEntry.isCurrentSharedAsGroup;
      if (!valCurrentOwner && valSharedAsGroup) {
        return false;
      }
      return true;
    };

    $scope.remove = function (queryEntry) {
      return AssignService.currentUserIsOwner(queryEntry.search.id).then(function (isOwner) {
        if (isOwner) {
          removeQueryFromList(queryEntry);
          // and finally remove the query
          if (queryEntry.search.id !== undefined) {
            return ContentService.getContent({id: queryEntry.search.id}).then(function (query) {
              return ContentService.deleteContent({id: query.id, revision: query.revision}).then(function () {
                return query;
              });
            });
          }
        } else {
          // Try to unshare
          return AssignService.unshare(queryEntry.search.id).then(function (shouldRemove) {
            if (shouldRemove) {
              removeQueryFromList(queryEntry);
            } else {
              var queryName = atex.onecms.ObjectUtils.getByPath(queryEntry, 'search/container/aspects/contentData/data/name');
              var message = "The query '" + queryName + "' is shared to a group!";
              DamNotificationService.addNotification(atex.dam.Notification({type: 'warning', message: message}), true);
            }
          });
        }
      });
    };

    $scope.update = function (queryEntry, isFromSave) {
      if (!isFromSave) {
        var obj = queryEntry.search.container;
        if (obj.aspects.contentData.data.name === queryEntry.name) {
          return $q.when(queryEntry);
        }
        obj.aspects.contentData.data.name = queryEntry.name;
      }
      if (queryEntry.search.id) {
        if ( queryEntry.search.container.aspects.contentData.data ) {
          var removeList = ["values", "clearValues", "readOnly", "forPrint"];
          var data = queryEntry.search.container.aspects.contentData.data;

          removeList.forEach(function( member ) {
            if ( data[member] ) {
              delete data[member];
            }
          });
        }

        var transferInfo = {
          id: queryEntry.search.id,
          data: queryEntry.search.container,
          revision: queryEntry.search.revision
        };
        return ContentService.updateContent(transferInfo).then(function (response) {
          return ContentService.getContent({id: response.id}).then(function (response) {
            queryEntry.search.container.aspects = response.data.aspects;
            queryEntry.search.status = 'query-list-status-saved';
            queryEntry.search.id = response.id;
            queryEntry.search.revision = response.revision;
            return queryEntry;
          });
        });
      } else {
        return $scope.save(queryEntry);
      }
    };

    var loadFromServer = function (id) {
      return ContentService.getContent({id: id}).then(function (response) {
        var search = {
          response: [],
          container: {
            aspects: response.data.aspects
          },
          damid: DamService.UUID(),
          status: 'query-list-status',
          id: response.id,
          revision: response.revision
        };
        entry(search);
      });
    };

    function queries(runQueryId) {
      if ($scope.loading) {
        return;
      }
      $scope.loading = true;
      DamQueryService.getAllQueries().then(function (response) {
        var promises = [];
        angular.forEach(response.data.response.docs, function (doc) {
          promises.push(loadFromServer(doc.id));
        });
        $q.all(promises).then(function () {
          sortQueries();
          $scope.loading = false;
          $scope.reloading = false;
          if (runQueryId) {
            runSavedSearch(runQueryId);
          }
        });
      });
    }

    /*
      The IsOpen of the accordian is two levels above this scope
     */
    if ($scope.$parent.$parent.isOpen) {
      queries();
    }
    $scope.$parent.$parent.$watch('isOpen', function (newValue, oldValue) {
      if (newValue) {
        queries();
      }
    });

    function buildFilteredQueryStr(queryContentData) {
      if (queryContentData.data.includeTrash!=="true") {
        return queryContentData.data.solrQueryString + configuration.getQueryFilterTrash();
      }
      return queryContentData.data.solrQueryString;
    }

    function entry(search, fromAssign) {
      var queryEntry = _.find($scope.queries, function (queryEntry) {
        return queryEntry.search.damid === search.damid || (typeof queryEntry.search.id !== 'undefined' && queryEntry.search.id === search.id);
      });
      var googleSearch = search.googleSearch;
      delete search.googleSearch;
      if (!queryEntry) {
        // Create new queryEntry
        queryEntry = {};
        queryEntry.size = (search.response.numFound !== undefined) ? search.response.numFound : 0;
        queryEntry.search = angular.copy(search);
        queryEntry.status = (search.status !== undefined) ? search.status : 'query-list-status-not-saved';
        queryEntry.name = search.container.aspects.contentData.data.name;
        queryEntry.increment = 0;
        queryEntry.googleSearch = googleSearch;
        setIsCurrentOwner(queryEntry);

        $scope.queries.push(queryEntry);
        $rootScope.queriesAccessible = $scope.queries;
        // Do not add not saved queries to poller
        /*
        if (queryEntry.search.container.aspects.contentData.data.isDynamic === 'true' && !search.status) {
          DamDynamicQueriesService.addUpdateQuery(queryEntry.search.damid, buildFilteredQueryStr(queryEntry.search.container.aspects.contentData));
        }
        */
      } else {
        // Update the queryEntry
        if (!fromAssign) {
          queryEntry.size = (search.response.numFound !== undefined) ? search.response.numFound : 0;
        }
        queryEntry.name = search.container.aspects.contentData.data.name;
        queryEntry.search.container = angular.copy(search.container);
        if (search.revision) {
          queryEntry.search.revision = search.revision;
        }

        // Do not add not saved queries to poller, so check also queryEntry.status
        if (search.container.aspects.contentData.data.isDynamic === 'true' && !fromAssign && queryEntry.status !== 'query-list-status-not-saved') {
          DamDynamicQueriesService.addUpdateQuery(search.damid, buildFilteredQueryStr(search.container.aspects.contentData));
        }

        if (fromAssign) {
          setIsCurrentOwner(queryEntry);
        }
      }
    }

    $scope.edit = function (editingQueryEntry) {

      var queryEntryCopy = angular.copy(editingQueryEntry);
      var physicalPages = atex.onecms.ObjectUtils.getByPath(queryEntryCopy, "search/container/aspects/contentData/data/physicalPages");
      var template = (physicalPages === "true") ? "views/dam-physical-pages-edit-query.html" : "views/dam-edit-query.html";

      var editScope = $rootScope.$new(true);
      editScope.query = queryEntryCopy.search.container.aspects.contentData.data;
      var modal = $modal({
        show: true,
        scope: editScope,
        template: template,
        modalClass: 'dam-edit-query confirm-modal ng-cloak',
        keyboard: false
      });

      editScope.$on('modal-hide.bs.modal', function (event, data) {
        editScope.$destroy();
        if (data && data.target) {
          $timeout(function () {
            data.target.remove();
          });
        } else {
          console.log("ERROR: expected data.target on modal-hide.bs.modal");
        }
      });

      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.modal('hide');
        });
      };

      editScope.doCancel = function () {
        destroyModal();
      };

      editScope.doSave = function (query) {
        if (editScope.saving) {
          return;
        }
        editScope.saving = true;
        var query2Save = angular.copy(query);
        var isDyn = atex.onecms.ObjectUtils.getByPath(query2Save, 'isDynamic') === 'true';

        var queryContentCopy = angular.copy(editingQueryEntry.search.container);
        queryContentCopy.aspects.contentData.data = query;
        // Resolve first the solrQueryString
        DamService.getQuery(queryContentCopy).then(function (solrQueryStringResponse) {
          query2Save.solrQueryString = solrQueryStringResponse.data.solr_query;
          // If it's a new query not saved, not update server side
          if (editingQueryEntry.status !== 'query-list-status-not-saved') {
            AssignService.currentUserIsOwner(editingQueryEntry.search.id).then(function (isOwner) {
              if (isOwner) {
                // Update the current query if the current user is owner
                editingQueryEntry.search.container.aspects.contentData.data = query2Save;
                $scope.update(editingQueryEntry, true).then(function (queryEntry) {
                  if (!isDyn) {
                    DamDynamicQueriesService.removeQuery(editingQueryEntry.search.damid);
                  }
                  editScope.saving = false;
                  destroyModal();
                  $scope.search(editingQueryEntry);
                }).then(null, function () {
                  editScope.saving = false;
                });
              } else {
                var queryName = atex.onecms.ObjectUtils.getByPath(queryEntryCopy, 'search/container/aspects/contentData/data/name');
                $translate('__NO_PERMISSION_TO_EDIT_QUERY__', {queryName: queryName}).then(function(message){
                    DamNotificationService.addNotification(atex.dam.Notification({
                      type: 'warning',
                      message: message
                    }), true);
                });
                // Create new query if the current user is not owner
                queryEntryCopy.search.container.aspects.contentData.data = query2Save;
                queryEntryCopy.status = 'query-list-status-not-saved';
                queryEntryCopy.search.damid = DamService.UUID();
                delete queryEntryCopy.search.id;
                delete queryEntryCopy.search.revision;
                editScope.saving = false;
                destroyModal();
                $scope.search(queryEntryCopy);
              }
            });
          } else {
            editingQueryEntry.search.container.aspects.contentData.data = query2Save;
            editingQueryEntry.name = query2Save.name;
            if (!isDyn) {
              DamDynamicQueriesService.removeQuery(editingQueryEntry.search.damid);
            }
            editScope.saving = false;
            destroyModal();
            $scope.search(editingQueryEntry);
            if (editingQueryEntry.name) {
              $scope.save(editingQueryEntry);
            }
          }
        });
      };
    };

    $scope.assign = function (queryEntry) {
      var assignScope = $rootScope.$new(true);
      assignScope.id = queryEntry.search.id;
      var modal = $modal({
        show: true,
        scope: assignScope,
        template: 'views/dam-assign.html',
        modalClass: 'dam-modal-assign confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });

      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            assignScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };

      assignScope.doCancel = function () {
        destroyModal();
      };

      assignScope.doOk = function () {
        destroyModal();
        ContentService.getContent({id: assignScope.id}).then(function (response) {
          queryEntry.search.container.aspects = response.data.aspects;
          queryEntry.search.status = 'query-list-status-saved';
          queryEntry.search.id = response.id;
          queryEntry.search.revision = response.revision;
          entry(queryEntry.search, true);
        });
      };
    };

    $scope.canRename = function (queryEntry) {
      if (queryEntry.isCurrentOwner === false) {
        return false;
      }
      return true;
    };

    $scope.rename = function (myform, queryEntry) {
      AssignService.currentUserIsOwner(queryEntry.search.id).then(function (isOwner) {
        if (isOwner) {
          myform.$show();
        } else {
          var queryName = atex.onecms.ObjectUtils.getByPath(queryEntry, 'search/container/aspects/contentData/data/name');
          var message = "No permission to rename the query '" + queryName + "'";
          DamNotificationService.addNotification(atex.dam.Notification({type: 'warning', message: message}), true);
        }
      });
    };

    $scope.reloadQueries = function (fromUi) {
      if ($scope.reloading) {
        return;
      }
      $scope.reloading = true;
      $scope.queries = [];
      $rootScope.queriesAccessible = $scope.queries;
      DamDynamicQueriesService.clearQueries();
      $scope.currentSearchDamID = undefined;
      queries();
      if (fromUi) {
        $rootScope.$broadcast("dam:openQueryList");
      }
    };

    $scope.close = function(id) {
      $('#dam-query-row-' + id).find('ul').hide();
    };

    var runSavedSearch = function(searchId) {
      angular.forEach($rootScope.queriesAccessible, function (queryEntry) {
        if (queryEntry.search.id === searchId) {
          $scope.search(queryEntry);
        }
      });
    };

    $scope.$on("dam:runSavedQuery", function(event, query) {
      console.log(query);
      if ($rootScope.queriesAccessible && $rootScope.queriesAccessible.length > 0) {
        runSavedSearch(query);
      } else {
        // Load the queries and run the specific
        queries(query);
      }
    });

    $scope.copyQueryUrlToClipboard = function(query) {
      var data = atex.onecms.ObjectUtils.getByPath(query, 'search/container/aspects/contentData/data');
      if (data) {
        var url = $location.absUrl().split('?')[0];
        var searchId = atex.onecms.ObjectUtils.getByPath(query, 'search/id');
        if (searchId) {
          url += 'search/saved/';
          url += encodeURIComponent(searchId);
        } else {
          var copy = JSON.parse(JSON.stringify(data));
          delete copy.solrQueryString;
          var cleaned = atex.dam.AngularUtils.cleanUpJson(copy);
          url += 'search/advanced/';
          url += encodeURIComponent(JSON.stringify(cleaned));
        }
        navigator.clipboard.writeText(url).then(function () {
          return DamNotificationService.addNotification(atex.dam.Notification({
            type: 'success',
            message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
          }), false);
        });
      }
    };
  }
]).directive('damQueryList', [function() {
  return {
    restrict: 'A',
    link: function (scope, element) {
      var buttonElem;
      var ulElement = element.find('ul');

      ulElement.click(function (e) {
        $(this).hide();
        e.stopPropagation();
      });

      element.find('button').click(function (e) {
        e.stopPropagation();
        buttonElem = element.find('button');
        dropDownFixPosition(buttonElem, ulElement);
      });

      scope.$on('$destroy', function () {
        if (buttonElem) {
          buttonElem.off("click");
        }
        buttonElem = undefined;
      });

      function dropDownFixPosition(button, dropdown) {
        if (dropdown.css("display") === 'block') {
          dropdown.hide();
        } else {
          dropdown.show();
        }

        var dropDownTop = button.offset().top + button.outerHeight();
        dropdown.css('position', "fixed");
        dropdown.css('max-width', "120px");
        dropdown.css('top', dropDownTop + "px");

        if (window.innerWidth < 500) {
          dropdown.css('left', button.offset().left - 150 + "px");
        } else {
          dropdown.css('left', button.offset().left + "px");
        }
      }
    }
  };
}]);
